import React from 'react';
import ContactForm from './ContactForm';
import { initReactApp } from 'shared/util/ApplicationInit';

const render = initReactApp(() => <ContactForm />, 'contact-form');

render();

// optional, use this to enable hot reloading
if ((module as any).hot) {
	(module as any).hot.accept('./ContactForm', () => {
		render();
	});
}
